import axios from "axios";
import { Button, Text } from "components";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeliveryChallanServiceItemAdd from "./DeliveryChallanService/DeliveryChallanServiceItemAdd";

function SalesOrderDeliveryChallanItemAdd() {
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [visible, setVisible] = useState(true);
  const [tempQuantities, setTempQuantities] = useState({});
  const [tempCostPrices, setTempCostPrices] = useState({});
  const [itemdeliverydate, setitemdeliverydate] = useState();
  const [isGoods, setIsGoods] = useState(true); // Default: Goods
  const [erplist, setErplist] = useState([]);
  const { id, customer_id } = useParams();
  const location = useLocation();
  const is_delivery_challan = location.state?.is_delivery_challan;
  const code = location.state?.code;
  let navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const fetchItems = async () => {
    const obj = { id: id };
    try {
      const response = await axios.post(
        "/api/purple-fusion/salesorder/salesorder/deliverychallan/items/get",
        obj,
        headers
      );
      setItems(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
      setErrorMessage("Failed to load items.");
    }
  };
  const obj = { id: id };
  const SalesOrder = () => {
    axios
      .post("/api/purple-fusion/salesorder/get", obj, headers)
      .then((response) => {
        // console.log(response.data[0].delivery_date);
        setitemdeliverydate(response.data[0].delivery_date);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchItems();
    setTimeout(() => {
      SalesOrder();
    }, 1000);
  }, []);
  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");
    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const handleCheckboxChange = (event, item) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setSelectedItems((prev) => [...prev, item]);
      setErrorMessage(""); // Clear error message when an item is selected
    } else {
      setSelectedItems((prev) =>
        prev.filter(
          (i) => i.delivery_challan_item_id !== item.delivery_challan_item_id
        )
      );
      // Remove from tempQuantities and tempCostPrices if item is unselected
      const newTempQuantities = { ...tempQuantities };
      const newTempCostPrices = { ...tempCostPrices };
      delete newTempQuantities[item.delivery_challan_item_id];
      delete newTempCostPrices[item.delivery_challan_item_id];
      setTempQuantities(newTempQuantities);
      setTempCostPrices(newTempCostPrices);
    }
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const filteredItems = items.filter((item) =>
        item.item_name?.toLowerCase().includes(searchTerm?.toLowerCase())
      );
      setSelectedItems(filteredItems);
      setErrorMessage(""); // Clear error message when all items are selected
    } else {
      setSelectedItems([]);
      setTempQuantities({});
      setTempCostPrices({});
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    // if (event.target.value === "") {
    //   setSelectedItems([]);
    // }
  };

  const handleQuantityChange = (event, item) => {
    const newQuantity = parseFloat(event.target.value);
    console.log(newQuantity);

    setTempQuantities((prev) => ({
      ...prev,
      [item.delivery_challan_item_id]: newQuantity,
    }));
  };

  const handleCostPriceChange = (event, item) => {
    const newCostPrice = parseFloat(event.target.value);
    setTempCostPrices((prev) => ({
      ...prev,
      [item.delivery_challan_item_id]: newCostPrice,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (selectedItems.length === 0) {
      setErrorMessage("Please select at least one item.");
      return;
    }

    // Calculate quantity and cost price for the selected items
    const updatedItems = selectedItems.map((item) => {
      const tempQuantity =
        tempQuantities[item.delivery_challan_item_id] ||
        item.initial_quantity - item.sales_order_moved_quantity;
      const tempCostPrice =
        tempCostPrices[item.delivery_challan_item_id] || item.cost_price;

      return {
        ...item,
        quantity: tempQuantity,
        cost_price: tempCostPrice,
        sales_order_id: id,
        delivery_date: itemdeliverydate,
      };
    });

    axios
      .post(
        "/api/purple-fusion/salesorderitem/create/salesorder/dc",
        updatedItems,
        headers
      )
      .then((response) => {
        // console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,

              onClose: () => {
                if (
                  erplist.some(
                    (item) => item.erp_module_id === 25 && item.add && item.view
                  )
                ) {
                  navigate(
                    `/salesorderotherdetails/add/${id}/${customer_id}?someKey=true`,
                    {
                      state: {
                        code: code,
                        is_delivery_challan: is_delivery_challan,
                      },
                    }
                  );
                  setVisible(false);
                } else {
                  toast.warning(
                    "don't have access to sales order other deatial",
                    {
                      autoClose: 2000,
                      onClose: () => {
                        navigate(`/salesorder/list`);
                        setVisible(false);
                      },
                    }
                  );
                }
              },
            })
          : toast.error(message, {
              autoClose: 2000,
              onClose: () => {},
            });
      })
      .catch((error) => {
        console.log(error);
        setVisible(false);
        navigate("*");
      });

    console.log("Updated Items for submission:", updatedItems);
  };

  const customStyles = {
    content: {
      width: "95%",
      height: "85%",
      margin: "auto",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };

  const allItemsSelected = items
    .filter((item) =>
      item.item_name?.toLowerCase().includes(searchTerm?.toLowerCase())
    )
    .every((item) =>
      selectedItems.some(
        (selectedItem) =>
          selectedItem.delivery_challan_item_id ===
          item.delivery_challan_item_id
      )
    );

  const handleToggle = () => {
    setIsGoods(!isGoods);
  };

  return (
    <Modal isOpen={visible} style={customStyles}>
      <form onSubmit={handleSubmit}>
        <div className="flex flex-row w-[100%] pt-3 px-3 items-center justify-center">
          <div className="flex flex-row sm:gap-15 items-center justify-start w-full">
            <Text
              className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px]"
              size="txtInterMedium24"
            >
              Sales order &gt; {code} &gt; Sales Order Items
            </Text>
          </div>
          <div className="flex flex-row items-center justify-end">
            <Button
              className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
              shape="round"
              color="blue_A700"
              size="base"
              variant="fill"
              type="submit"
            >
              Save
            </Button>
            <Button
              className="cursor-pointer sticky font-small mb-3 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
              shape="round"
              color="white"
              size="base"
              variant="fill"
              onClick={() => {
                setVisible(false);
                navigate(`/salesorderall/${id}/${customer_id}`, {
                  state: {
                    code: code,
                    is_delivery_challan: is_delivery_challan,
                  },
                });
              }}
            >
              ╳
            </Button>
          </div>
        </div>

        {/* <label className="flex items-center gap-2">
          <span>Goods</span>
          <input type="checkbox" checked={!isGoods} onChange={handleToggle} />
          <span>Services</span>
        </label>

        <h2 className="text-lg font-semibold mt-4">
          {isGoods ? "Goods Form" : "Services Form"}
        </h2> */}

        <ToastContainer />
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search items..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="w-[20%] px-3 py-2 border border-gray-300 rounded-md"
          />
        </div>

        {errorMessage && (
          <div className="mb-4 text-red-500">{errorMessage}</div>
        )}
        {isGoods ? (
          <div className="overflow-auto max-h-[380px]">
            <table className=" divide-gray-200 ">
              <thead className="bg-gray-200 border sticky top-0 z-10">
                <tr>
                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase border tracking-wider">
                    <input
                      type="checkbox"
                      onChange={handleSelectAll}
                      checked={allItemsSelected}
                      className="form-checkbox rounded h-5 w-5 text-blue-600"
                    />
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase tracking-wider border">
                    Name
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase tracking-wider border">
                    DC Code
                  </th>
                  <th className="px-3 py-3 text-left text-sm whitespace-nowrap  font-medium text-black-900 uppercase tracking-wider border">
                    Quantity
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium whitespace-nowrap  text-black-900 uppercase tracking-wider border">
                    Cost Price
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase tracking-wider border">
                    Item Amount
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium  text-black-900 uppercase tracking-wider border">
                    SGST (%)
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase tracking-wider border">
                    CGST (%)
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase tracking-wider border">
                    IGST (%)
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase tracking-wider border">
                    Initial Quantity
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium  text-black-900 uppercase tracking-wider border">
                    Sales Order Moved Quantity
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase tracking-wider border">
                    Description
                  </th>
                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase tracking-wider border">
                    HSN / SAC Code
                  </th>

                  <th className="px-3 py-3 text-left text-sm font-medium text-black-900 uppercase tracking-wider border">
                    Tax Amount
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white border divide-y divide-gray-200">
                {items
                  .filter((item) =>
                    item.item_name
                      ?.toLowerCase()
                      .includes(searchTerm?.toLowerCase())
                  )
                  .map((item) => {
                    const isSelected = selectedItems.some(
                      (selectedItem) =>
                        selectedItem.delivery_challan_item_id ===
                        item.delivery_challan_item_id
                    );
                    const quantity = isSelected
                      ? tempQuantities[item.delivery_challan_item_id] ||
                        item.initial_quantity - item.sales_order_moved_quantity
                      : item.initial_quantity - item.sales_order_moved_quantity;
                    const costPrice = isSelected
                      ? tempCostPrices[item.delivery_challan_item_id] ||
                        item.cost_price
                      : item.cost_price;
                    const itemAmount = quantity * costPrice;
                    const sgst = itemAmount * (item.sgst_percentage / 100);
                    const cgst = itemAmount * (item.cgst_percentage / 100);
                    const igst = itemAmount * (item.igst_percentage / 100);
                    const taxAmount = sgst + cgst + igst;

                    return (
                      <tr key={item.delivery_challan_item_id}>
                        <td className="px-3 py-3 whitespace-nowrap border">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) => handleCheckboxChange(e, item)}
                            className="form-checkbox rounded h-5 w-5 text-blue-600"
                          />
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {item.item_name}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {item.code}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap min-w-fit w-full border">
                          {isSelected ? (
                            <input
                              type="number"
                              name="quantity"
                              min="1.00"
                              max={
                                item.initial_quantity -
                                item.sales_order_moved_quantity
                              }
                              step="0.0001"
                              value={
                                tempQuantities[
                                  item.delivery_challan_item_id
                                ] !== undefined
                                  ? tempQuantities[
                                      item.delivery_challan_item_id
                                    ]
                                  : item.initial_quantity -
                                    item.sales_order_moved_quantity
                              }
                              onChange={(e) => handleQuantityChange(e, item)}
                              className="w-full px-3 py-1 border border-gray-300 rounded-md min-w-fit"
                            />
                          ) : (
                            item.initial_quantity -
                            item.sales_order_moved_quantity
                          )}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap min-w-fit w-full border">
                          {isSelected ? (
                            <input
                              name="cost_price"
                              type="number"
                              min="0"
                              step="0.0001"
                              value={
                                tempCostPrices[
                                  item.delivery_challan_item_id
                                ] !== undefined
                                  ? tempCostPrices[
                                      item.delivery_challan_item_id
                                    ]
                                  : item.cost_price
                              }
                              onChange={(e) => handleCostPriceChange(e, item)}
                              className="w-full px-3 py-1 border border-gray-300 rounded-md min-w-fit"
                            />
                          ) : (
                            item.cost_price
                          )}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {itemAmount.toFixed(2)}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {item.sgst_percentage}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {item.cgst_percentage}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {item.igst_percentage}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {item.initial_quantity}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {item.sales_order_moved_quantity}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {item.description}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {item.hsn_code ? item.hsn_code : item.sac_code}
                        </td>
                        {/* New Tax Amount Column */}
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900 border">
                          {taxAmount.toFixed(2)}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
              <tfoot className="bg-gray-300 sticky bottom-0 z-10">
                <tr>
                  <td
                    colSpan="3"
                    className="px-3 py-1 text-left text-lg font-semibold text-gray-900"
                  >
                    Total
                  </td>
                  <td
                    colSpan="2"
                    className="px-3 py-1 text-left text-lg font-semibold text-gray-900"
                  >
                    {items.reduce((total, item) => {
                      const isSelected = selectedItems.some(
                        (selectedItem) =>
                          selectedItem.delivery_challan_item_id ===
                          item.delivery_challan_item_id
                      );
                      const quantity = isSelected
                        ? tempQuantities[item.delivery_challan_item_id] ||
                          item.initial_quantity -
                            item.sales_order_moved_quantity
                        : item.initial_quantity -
                          item.sales_order_moved_quantity;
                      return total + (isSelected ? quantity : 0);
                    }, 0)}
                  </td>
                  <td className="px-3 py-1 text-left text-lg font-semibold text-gray-900">
                    {items
                      .reduce((total, item) => {
                        const isSelected = selectedItems.some(
                          (selectedItem) =>
                            selectedItem.delivery_challan_item_id ===
                            item.delivery_challan_item_id
                        );
                        const quantity = isSelected
                          ? tempQuantities[item.delivery_challan_item_id] ||
                            item.initial_quantity -
                              item.sales_order_moved_quantity
                          : item.initial_quantity -
                            item.sales_order_moved_quantity;
                        const costPrice = isSelected
                          ? tempCostPrices[item.delivery_challan_item_id] ||
                            item.cost_price
                          : item.cost_price;
                        return total + (isSelected ? quantity * costPrice : 0);
                      }, 0)
                      .toFixed(2)}
                  </td>
                  <td
                    colSpan="7"
                    className="px-3 py-1 text-left text-lg font-semibold text-gray-900"
                  ></td>
                  <td className="px-3 py-1 text-left text-lg font-semibold text-gray-900">
                    {items
                      .reduce((total, item) => {
                        const isSelected = selectedItems.some(
                          (selectedItem) =>
                            selectedItem.delivery_challan_item_id ===
                            item.delivery_challan_item_id
                        );
                        const quantity = isSelected
                          ? tempQuantities[item.delivery_challan_item_id] ||
                            item.initial_quantity -
                              item.sales_order_moved_quantity
                          : item.initial_quantity -
                            item.sales_order_moved_quantity;
                        const costPrice = isSelected
                          ? tempCostPrices[item.delivery_challan_item_id] ||
                            item.cost_price
                          : item.cost_price;
                        const itemAmount = quantity * costPrice;
                        const sgst = itemAmount * (item.sgst_percentage / 100);
                        const cgst = itemAmount * (item.cgst_percentage / 100);
                        const igst = itemAmount * (item.igst_percentage / 100);
                        return total + (isSelected ? sgst + cgst + igst : 0);
                      }, 0)
                      .toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        ) : (
          <DeliveryChallanServiceItemAdd sales_order_id={id} />
        )}
      </form>
    </Modal>
  );
}

export default SalesOrderDeliveryChallanItemAdd;
